import { UAGLogo } from "@components/icons"
import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import { body14Styles, smallcapsBold13Styles } from "@constants/typography"
import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"

const Container = styled.div`
  align-items: center;
  justify-content: center;
  display: inline-flex;
`

const Button = styled.span`
  align-items: center;
  justify-content: center;
  display: flex;
  padding: 0;
  outline: none;
  border: none;
  background: none;

  &:focus,
  &:active {
    outline: none;
  }

  @media ${breakpoints.laptop} {
    &:hover {
      cursor: pointer;
    }
  }
`

const LogoWrapper = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
`

export const UAGLogoWrapper = styled(LogoWrapper)`
  width: 52.12px;

  @media ${breakpoints.tablet} {
    width: 75px;
  }

  @media ${breakpoints.laptop} {
    width: 75px;
  }
`

export const DropdownArrow = styled.div`
  content: "";
  height: 20px;
  width: 20px;
  background-color: black;
  transform: rotate(45deg) translateX(0px) translateY(40px);

  @media ${breakpoints.largerThanMobile} {
    transform: rotate(45deg) translateX(0px) translateY(50px);
  }
`

export const DropdownBody = styled.div`
  position: absolute;
  background-color: black;
  top: 100%;
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  padding: 20px;

  transform: translateX(-80px) translateY(-5px);

  @media ${breakpoints.largerThanMobile} {
    transform: translateX(-80px) translateY(-10px);
  }
`

export const DropdownWrapper = styled.div``

export const DropdownSvg = styled.svg`
  &:hover ~ {
    opacity: 1;
  }
`

export const DropdownText = styled.span`
  ${smallcapsBold13Styles}
  color: white;
`

export const DropdownShopAllUAG = styled(Link)`
  ${body14Styles}

  margin-top: 10px;
  color: ${colors.mediumDarkGray};
  text-decoration: underline;
`

interface LogoProps {}

const Logo: React.FC<LogoProps> = () => {
  return (
    <Container>
      <Link aria-label="Home" to="/">
        <Button>
          <UAGLogoWrapper>
            <UAGLogo strokeColor={colors.black} />
          </UAGLogoWrapper>
        </Button>
      </Link>
    </Container>
  )
}

export default Logo
